module.exports = __webpack_public_path__ + "media/images/mailer/badge_appstore-light-744c229f0d4a5f0eb6c6967e700cc67b.png";